module.exports = __webpack_public_path__ + "static/img/image_set_otameshi.09b2c28.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_set_otameshi.jpg
// module id = XqCg
// module chunks = 1